import { useState, useSyncExternalStore } from "react";
import type { CalendarViewMode } from "./types.js";

const MOBILE_CALENDAR_QUERY = "(max-width: 767px)";
const COMPACT_CALENDAR_QUERY = "(max-width: 1023px)";

function subscribeToViewport(query: string, onChange: () => void): () => void {
  const media = window.matchMedia(query);
  media.addEventListener("change", onChange);
  return () => media.removeEventListener("change", onChange);
}

export function useViewportQuery(query: string): boolean {
  return useSyncExternalStore(
    (onChange) => subscribeToViewport(query, onChange),
    () => window.matchMedia(query).matches,
    () => false,
  );
}

export function useMobileCalendarView(initialView: CalendarViewMode) {
  const isMobile = useViewportQuery(MOBILE_CALENDAR_QUERY);
  const isCompact = useViewportQuery(COMPACT_CALENDAR_QUERY);
  const [desktopView, setDesktopView] = useState<CalendarViewMode>(
    initialView === "timeGridDay" ? "timeGridWeek" : initialView,
  );

  return {
    isMobile,
    isCompact,
    // Неделя нечитаема только на телефоне; планшету оставляем полный переключатель видов.
    view: isMobile ? ("timeGridDay" as const) : desktopView,
    setView: setDesktopView,
  };
}
